import './VolumeIndicator.less';
import MicrophoneLogo from '@/assets/recording/microphone-indicator.svg';
import AiVoiceMicrophoneLogo from '@/assets/recording/ai-voice-microphone.svg';

export default function VolumeIndicator({ volume = 0, type }) {
  const defaultHeightList = [
    17, 55, 37, 43, 73, 53, 87, 37, 43, 29, 15, 25, 43, 29, 73, 17, 55, 37, 43, 73, 64, 87, 37, 43,
    19, 15, 25, 43, 29, 73, 43, 59, 73, 43, 21, 15, 29, 19, 20, 35, 21, 32, 30, 21, 15, 29, 11, 17,
    29, 17, 17, 55, 37, 43, 73, 69, 87, 37, 43, 19, 15, 25, 43, 29, 73, 17, 55, 37, 43, 73, 63, 87,
    37, 43, 29, 15, 25, 43, 29, 73, 43, 59,
  ];

  const iconList = defaultHeightList.map((item, index) => {
    return <i key={index} style={{ height: 4 + volume * item + 'px' }}></i>;
  });
  return (
    <div className={`volume-indicator ${type === 'ai' ? 'primary' : ''}`}>
      <div className="icon-list">{iconList}</div>

      <img src={type === 'ai' ? AiVoiceMicrophoneLogo : MicrophoneLogo} alt="" />
    </div>
  );
}
